import { StoreState } from '../store-interfaces';

export const selectActiveEmailAccounts = (state: StoreState) =>
  state.emailAccounts.entities.filter(acc =>
    acc.kind === 'sendgrid_platform' ? acc.status === 'verified' : true,
  );

export const selectAllEmailAccounts = (state: StoreState) =>
  state.emailAccounts.entities;
